import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { ShieldAlert, LogIn } from "lucide-react";

// Avvisa (modale bloccante) quando mancano al massimo 30 minuti alla scadenza della sessione.
const WARN_BEFORE_MS = 30 * 60 * 1000;

const fmtRemaining = (ms) => {
  if (ms <= 0) return "0:00";
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  return `${m}:${String(s).padStart(2, "0")}`;
};

const SessionExpiryModal = () => {
  const { user, logout, sessionExp } = useAuth();
  const [remaining, setRemaining] = useState(null); // ms alla scadenza; null = nascosto

  const relogin = useCallback(() => {
    logout();
    window.location.href = "/login";
  }, [logout]);

  useEffect(() => {
    if (!user || !sessionExp) {
      setRemaining(null);
      return;
    }
    const expMs = sessionExp * 1000; // token_exp è in secondi epoch
    const check = () => {
      const left = expMs - Date.now();
      if (left <= 0) {
        relogin();
        return;
      }
      setRemaining(left <= WARN_BEFORE_MS ? left : null);
    };
    check();
    const id = setInterval(check, 1000);
    return () => clearInterval(id);
  }, [user, sessionExp, relogin]);

  if (remaining == null) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-testid="session-expiry-modal">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 text-center">
        <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert size={28} className="text-amber-600" />
        </div>
        <h2 className="text-[19px] font-black text-[#16345c] mb-2">La sessione sta per scadere</h2>
        <p className="text-[14px] text-gray-600 mb-1">Per motivi di sicurezza la tua sessione scadrà tra</p>
        <div className="text-[26px] font-black text-amber-600 mb-3" data-testid="session-expiry-countdown">{fmtRemaining(remaining)}</div>
        <p className="text-[13px] text-gray-500 mb-5">Accedi di nuovo per continuare a lavorare senza interruzioni ed evitare la disconnessione improvvisa.</p>
        <button onClick={relogin} data-testid="session-expiry-relogin" className="w-full flex items-center justify-center gap-2 bg-[#16345c] hover:bg-[#0d1b2f] text-white text-[14px] font-bold px-4 py-3 rounded-sm transition-colors">
          <LogIn size={17} /> Accedi di nuovo
        </button>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
